import React from 'react'
import TimelineWidget3 from './TimelineWidget3'
import timeline from '../json/timeline.json'

const SampleTimelineWidget3 = () => <TimelineWidget3 items={timeline} />

export default SampleTimelineWidget3



// WEBPACK FOOTER //
// ./src/timeline-widgets/SampleTimelineWidget3.js